export const TOKEN = 'token';
export const COMPANY_ID = 'companyId';
export const INV_TOKEN = 'invitationToken';
export const RESET_PASS_TOKEN = 'resetPasswordToken';
export const DOWNLOAD = 'download';
export const BEARER_TOKEN = 'bearer_token';
export const AUTHORIZATION_HEADER = 'authorization';

